import React from 'react'
// import styles from './styles.module.css'

// export const ExampleComponent = ({ text }) => {
//   return <div className={styles.test}>Example Component: {text}</div>
// }

import styled from 'styled-components';

export const Button = styled.div`
  height: 38px;
  min-width: 250px;
  border-radius: 19px;
  border: 1px solid var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  text-transform: uppercase;
  font-size: 14px;
  font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  cursor: pointer;
  font-weight: bold;

  ${props =>
    props.disabled &&
    `
    border: 1px solid var(--light-grey);
    background-color: var(--light-grey);
    color: var(--light-black);
    cursor: default;
    `}

  &:hover {
    background-color: var(--white);
    color: var(--accent);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const AccentBorderButton = styled(Button)`
  border: 1px solid var(--accent);
  color: var(--accent);

  &:hover {
    background-color: var(--accent);
    color: var(--white);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const AccentButton = styled(Button)`
  border: 1px solid var(--accent);
  background-color: var(--accent);

  ${props =>
    props.disabled &&
    `
    border: 1px solid var(--light-grey);
    background-color: var(--light-grey);
    color: var(--light-black);
    cursor: default;
    `}

  &:hover {
    background-color: var(--accent);
    color: var(--white);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const WhiteButton = styled(Button)`
  border: 1px solid var(--white);
  background-color: var(--white);
  color: var(--black);

  &:hover {
    color: var(--accent);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const LText = styled.span`
  font-size: 20px;
`;

export const MText = styled.span`
  font-size: 16px;
`;

export const SText = styled.span`
  font-size: 12px;
`;

export const SmallHeader = styled.span`
  color: var(--light-black);
  font-size: 14px;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  border-width: ${props => props.height || 1}px;
  height: ${props => (!props.solid ? props.height : 0)}px;
  border-style: ${props => (props.solid ? 'solid' : undefined)};
  border-color: ${props => props.color || undefined};
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  margin: ${props => props.margin || 'none'};
`;
